import { IconButton, TableCell } from '@material-ui/core';
import DownIcon from '@mui/icons-material/ArrowDropDown';
import UpIcon from '@mui/icons-material/ArrowDropUp';
import React from 'react';

export const CollapsibleRowToggle = ({ handleCollapsibleOpen, open }) => (
  <TableCell style={{ padding: 0, paddingLeft: 8, paddingRight: 8, width: 0 }}>
    <IconButton aria-label="expand row" size="small" onClick={handleCollapsibleOpen}>
      {open ? <UpIcon /> : <DownIcon />}
    </IconButton>
  </TableCell>
);
